module.exports = __webpack_public_path__ + "static/media/hotelPageDaycareIcon.b94fb904.png";